import { render, staticRenderFns } from "./info-vision.vue?vue&type=template&id=2fa1bb82&scoped=true&"
import script from "./info-vision.vue?vue&type=script&lang=js&"
export * from "./info-vision.vue?vue&type=script&lang=js&"
import style0 from "./info-vision.vue?vue&type=style&index=0&id=2fa1bb82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa1bb82",
  null
  
)

export default component.exports